/* eslint-disable no-console */
<template>
  <div class="material-list-box-wrapper" v-show="show">
    <div :class="{main: true}">
      <div class="title">{{config.type == 'more' ? '检索更多' : '近期查看'}}</div>
      <img class="close" @click="close" src="../../assets/img/common/close.svg" alt="">
      <div ref="listContainer" class="list-container" :class="{empty:list&&!list.length}">
        <empty v-if="list && list.length === 0&&!loadingMore" :msg="'暂无素材'" />
        <ul ref="list" class="list-content">
          <li @click="openDetail(item)" v-for="(item,index) in list" :key="index" :class="{list: true, on: item.status}">
            <div class="cover">
              <div class="bg" :style="{'background-image': `url(${item.cover ||(+item.type==3?defaultAudioImg: defaultImg)})`}"></div>

              <img v-show="+item.type >1" class="playBtn" src="@assets/img/index/play.svg" alt="">
              <img v-show="item.is_new-0 === 1&&item.status === false" class="newIcon" src="@assets/img/common/new-bold.svg" alt="">
            </div>
            <div class="detail">
              <p class="title">
                <img v-show="item.type-0 === 1" src="@assets/img/common/imgIcon.svg" alt="img">
                <img v-show="item.type-0 === 3" src="@assets/img/common/audioIcon.svg" alt="img">
                <img v-show="item.type-0 === 2" src="@assets/img/common/videoIcon.svg" alt="img">
                <img v-show="item.type-0 === 4" src="@assets/img/common/articleIcon.png" alt="img">
                <span v-html="item.title"></span>
              </p>
            </div>
          </li>
          <li class="fillItem" :style="{height: 0, width: `${fillWidth}px`}"></li>
        </ul>
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import empty from "@components/empty";
import pages from "@components/pages";
import store from "@common/store";
export default {
  name: "MaterialListBox",
  data() {
    return {
      upload_limit_num: 10,
      showMore: true,
      show: true,
      config: {},
      detail: {},
      r: null,
      page: {
        pageCount: 0,
        pageSize: 8,
        pageIndex: 1,
        total: 0
      },
      typeIndex: "",
      dateIndex: "",
      start: "",
      end: "",
      loadingMore: false,
      list: [],
      fillWidth: 0,
      itemHeight: 0,
      defaultImg: require("@assets/img/common/default.png"),
      defaultAudioImg: require("@assets/img/common/audioMask.jpg"),
      num: 0,
      reachBottom: false,
      timer: null,
      searchOptions: {}
    };
  },
  //   computed:{
  // reachBottom(){
  //   return this.gap>
  // }
  //   },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    // this.$watch(
    //   reachBottom,
    //   this.debounce(() => {
    //     // this.loadMore
    //     this.getList();
    //   }, 500)
    // );
  },
  methods: {
    openDetail(detail) {
      let data = {
        type: detail.type,
        id: this.config.type == 'more' ? detail.id : detail.file_id, 
        create: store.state.create,
        canEdit: false,
        quickEdit: store.state.quickEdit,
        keywords: this.config.title,
        search_from: 'bubble',
        search_hit: JSON.stringify(detail.search_hit),
        vector_result: detail.vector_result
      };
      this.$materialBox(data);
    },
    open(c, r, callback) {
      console.log(c)
      this.config = c;
      this.r = r;
      this.callback = callback;
      this.getList();
      // 禁止滚动 穿透
      window.document.body.classList.add("prevent-scroll");
      this.show = true;
    },
    close() {
      window.document.body.classList.remove("prevent-scroll");
      this.show = false;
    },
    cancle() {
      this.close();
    },
    getList() {
      if(this.config.type == 'more'){
        let info = {
          key_words: this.config.title,
          search_from: 'bubble',
          search_model: 3,
          page_type: 'file',
          page: this.page.pageIndex,
          pagesize: 8
        }
        common
        .myFetch(apis.fileList,info)
        .then(res => {
          if (res) {
            this.list = res.list;
            this.$set(
              this.page,
              "pageCount",
              common.calculatePage(res.page.row_count - 0, this.page.pageSize)
            );
            this.$set(this.page, "total", res.page.row_count - 0);
              console.log(6666,res)
            }
        });
      }else{
        let info = {
          page: this.page.pageIndex,
          pagesize: 8
        }
        common
        .myFetch(apis.viewhistory, info)
        .then(res => {
          if (res) {
            this.list = res.list;
            this.$set(
              this.page,
              "pageCount",
              common.calculatePage(res.page.row_count - 0, this.page.pageSize)
            );
            this.$set(this.page, "total", res.page.row_count - 0);
              console.log(6666,res)
            }
        });
      }
    }
  },

  components: { empty, pages }
};
</script>

<style lang='less'>
.pages {
  margin: 0 !important;
}

.prevent-scroll {
  height: 100%;
  overflow: hidden;
}
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangTC-Medium;
  font-size: 14px;
  color: #829191;
  height: 30px;
  .loadEffect {
    width: 100px;
    height: 100px;
    position: relative;
    transform: scale(0.3);
    margin-right: -25px;
  }
  .loadEffect span {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #41b48c;
    position: absolute;
    -webkit-animation: load 1.04s ease infinite;
  }
  @-webkit-keyframes load {
    0% {
      -webkit-transform: scale(1.2);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(0.3);
      opacity: 0.5;
    }
  }
  .loadEffect span:nth-child(1) {
    left: 0;
    top: 50%;
    margin-top: -10px;
    -webkit-animation-delay: 0.13s;
  }
  .loadEffect span:nth-child(2) {
    left: 14px;
    top: 14px;
    -webkit-animation-delay: 0.26s;
  }
  .loadEffect span:nth-child(3) {
    left: 50%;
    top: 0;
    margin-left: -10px;
    -webkit-animation-delay: 0.39s;
  }
  .loadEffect span:nth-child(4) {
    top: 14px;
    right: 14px;
    -webkit-animation-delay: 0.52s;
  }
  .loadEffect span:nth-child(5) {
    right: 0;
    top: 50%;
    margin-top: -10px;
    -webkit-animation-delay: 0.65s;
  }
  .loadEffect span:nth-child(6) {
    right: 14px;
    bottom: 14px;
    -webkit-animation-delay: 0.78s;
  }
  .loadEffect span:nth-child(7) {
    bottom: 0;
    left: 50%;
    margin-left: -10px;
    -webkit-animation-delay: 0.91s;
  }
  .loadEffect span:nth-child(8) {
    bottom: 14px;
    left: 14px;
    -webkit-animation-delay: 1.04s;
  }
}
</style>
<style lang="less" scoped>
@import "../../assets/css/global.less";

.material-list-box-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  top: 0;
  bottom: 0;
  z-index: 1001;
  background-color: rgba(#000, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  .main {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 1064px;
    height: 616px;
    padding: 20px 30px 30px;
    background-color: #fff;
    border-radius: 4px;

    & > .title {
      font-weight: bold;
      font-size: 24px;
      color: #050F0F;
      line-height: 33px;
    }

    &.min {
      height: 558px;
    }
  }
  .top-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 30px;
    .left {
      display: flex;
      align-items: center;
    }
    .title {
      font-family: PingFang-SC-Bold;
      font-size: 24px;
      color: #050f0f;
    }
    .chosen-number {
      font-family: PingFang-SC-Bold;
      font-size: 14px;
      color: #b9c3c3;
      margin-left: 10px;
    }
  }
  .close {
    position: absolute;
    right: 40px;
    top: 20px;
    width: 17px;
    height: 17px;
  }
}
.list-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  margin-top: 22px;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 4px;
  }
  &.empty {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .list-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    justify-content: start;
    position: relative;
    overflow-y: auto;
    flex: 1;
    min-height: 0;

    .list {
      margin-right: 12px;
      display: flex;
      flex-direction: column;
      width: 242px;
      height: fit-content;
      border-radius: 4px;
      border: 1px solid #dcdcdc;
      margin-bottom: 30px;
      box-sizing: border-box;
      user-select: none;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0;
      }
      &.on {
        background-color: rgba(185, 195, 195, 0.2);
      }

      .preview {
        display: none;
        position: absolute;
        top: 8px;
        left: 8px;
        width: 48px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: rgba(90,90,90,0.7);
        border-radius: 12px;
        font-size: 14px;
        color: #FFFFFF;
        user-select: none;
        cursor: pointer;

        &:hover {
          background: rgba(65,180,140,0.7);
        }
      }

      .verify-item {
        position: absolute;
        right: 0;
        bottom: 6px;
        background-color: rgba(@green, 0.5);
        line-height: 18px;
        border-radius: 50px 0 0 50px;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        font-size: 10px;
        font-weight: 700px;
        color: white;
        padding: 0 8px;
        &.verify-fail {
          background-color: rgba(#ff3e53, 0.5);
        }
        img {
          width: 11px;
          margin-right: 4px;
        }
      }
      .cover {
        position: relative;
        display: flex;
        width: 100%;
        height: 135px;
        // flex: 1;

        .bg {
          width: 100%;
          height: 100%;
          overflow: hidden;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }

        .playBtn {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 40px;
          height: auto;
        }

        .newIcon {
          position: absolute;
          top: 6px;
          right: 7px;
        }

        .selectIcon {
          display: none;
          position: absolute;
          top: 8px;
          right: 8px;
          width: 24px;
          height: 24px;
          border-radius: 12px;
          background-color: rgba(90, 90, 90, 0.7);
          user-select: none;
          cursor: pointer;

          &::after {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -7px;
            margin-top: -5.5px;
            content: "";
            display: block;
            width: 14px;
            height: 11px;
            background: url("../../assets/img/material/checked.svg") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          &.on {
            display: block;
            background-color: @green;
            &::after {
              position: absolute;
              top: 50%;
              left: 50%;
              margin-left: -7px;
              margin-top: -5.5px;
              content: "";
              display: block;
              width: 14px;
              height: 11px;
              background: url("../../assets/img/material/checked.svg") no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }
          }
        }
      }

      & > .detail {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        // height: 135px;
        padding: 10px 10px 12px;
        box-sizing: border-box;

        .title {
          font-size: 18px;
          height: 48px;
          min-height: 48px;
          line-height: 24px;
          font-weight: bold;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          word-break: break-all;
          img {
            vertical-align: middle;
            margin-right: 4px;
          }
        }

        .detail {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;

          p {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 14px;
            line-height: 18px;
            color: #b9c3c3;
            margin-bottom: 4px;
            min-width: 50%;

            &.clock {
              font-weight: bold;
              font-family: Arial;
            }

            &.share {
              display: flex;
              justify-content: flex-end;
            }

            &:nth-last-of-type(1) {
              margin-bottom: 0;
            }
          }
        }

        .edit {
          display: none;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 0 30px;
          box-sizing: border-box;

          div {
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            user-select: none;

            img {
              margin-right: 10px;
            }

            span {
              font-size: 14px;
              line-height: 18px;
              color: #41b48c;
            }
          }

          .line {
            width: 1px;
            height: 20px;
            background: #e6e6e6;
          }
        }
      }

      &:hover {
        border: 2px solid @green;
        box-sizing: border-box;

        .detail {
          box-sizing: border-box;

          .detail {
            display: none;
          }

          .edit {
            display: flex;
          }
        }

        .newIcon {
          display: none;
        }

        .selectIcon {
          display: block;
        }

        .preview {
          display: block;
        }
      }
    }
  }
}
.confirm-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .chosen-number {
    font-family: PingFang-SC-Bold;
    font-size: 14px;
    color: #b9c3c3;
    margin-left: 10px;
  }

  .selectAll-container {
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    user-select: none;
    cursor: pointer;

    i {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      border: 1px solid #B9C3C3;
      box-sizing: border-box;

      &.on {
        position: relative;
        background: #41b48c;
        border: 1px solid #41b48c;
        box-sizing: border-box;

        &::after {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -7px;
          margin-top: -5px;
          content: "";
          display: block;
          width: 14px;
          height: 11px;
          background: url("../../assets/img/material/checked.svg") no-repeat;
          background-position: center center;
          background-size: 100% 100%;
        }
      }
    }

    span {
      font-size: 14px;
      line-height: 18px;
      color: #323B4B;
      margin-left: 10px;
    }
  }
  .item {
    width: 120px;
    height: 40px;
    line-height: 40px;
    color: white;
    background-color: #41b48c;
    border-radius: 25px;
    text-align: center;
    user-select: none;
    cursor: pointer;
    &.cancel {
      background-color: #b9c3c3;
      margin-left: 20px;
    }
  }
}
.mask {
  background-color: #000;
  opacity: 0.7;
}
</style>
